import React from 'react'
import Modal from '../../common/components/Modal'

import {
	PrimaryButton,
	SecondaryButton,
	ButtonsBlock,
} from '../../Ui'

const DeleteModal = ({ isOpen, locking, onDelete, onClose }) =>
	<Modal
		isOpen={isOpen}
		mask="light"
		closeOnClickOutside
		closeOnEsc
		onClose={onClose}>
		<div className="bg-primary border-top border-bottom a-slide">
			<header className="p-1 text-center">Êtes-vous sûre de vouloir supprimer l&#39;ouverture "{locking.name}" ?</header>
			<ButtonsBlock>
				<SecondaryButton
					onClick={onClose}>

					Annuler
				</SecondaryButton>
				<PrimaryButton
					onClick={onDelete}>

					Supprimer
				</PrimaryButton>
			</ButtonsBlock>
		</div>
	</Modal>

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/js/plan/lockings/DeleteModal.js